// extracted by mini-css-extract-plugin
export default {"noTasksContainer":"NoTasks_noTasksContainer__eNE9t"};